<template>
  <router-link
    :to="{ name: 'session-view', params: { id: training.id } }"
    class="training-info training-info-many link-nostyle"
  >
    <div class="training-info-many-content">
      <span v-if="!isTrainingStatusPlan" class="training-date">
        {{ getTrainingStartTime(training) }}
      </span>
      <span v-else class="training-date">
        {{ getTrainingFormattedStartDate(training, true) }}
      </span>

      <div class="d-flex">
        <template v-if="isTrainingStandard">
          <div>
            <svg-icon
              :name="'clock'"
              :width="20"
              :height="20"
              :fill="getFillColor(training, 1)"
              class="mr-1"
            ></svg-icon>
            {{ trainingDurationString }}
          </div>
          <div>
            <svg-icon
              :name="'heart_rate'"
              :width="20"
              :height="20"
              :fill="getFillColor(training, 2)"
              class="mr-1 ml-3"
            ></svg-icon>
            {{ holdHRStr }}
          </div>
        </template>

        <template v-else>
          <div>
            <span
              style="padding: 1px 8px;
                         background: #3F4156;
                         color: white;
                         border-radius: 6px;
                         font-size: 16px;"
            >
              {{ $t('src/pages/trainingview.wt6m') }}
            </span>
          </div>
          <div class="ml-2">
            <svg-icon :name="'steps_fill'" :width="20" :height="20" class="mr-1"></svg-icon>
            <span>{{ getDistance(training) }}</span>
          </div>
        </template>
      </div>
    </div>
  </router-link>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
import { trainingDate } from '@/mixins/training-date.js'
import { trainingItem } from '@/mixins/training-item.js'

export default {
  name: 'TrainingDayDetailsMany',
  mixins: [trainingDate, trainingItem],
  components: {
    SvgIcon
  },
  props: {
    training: {
      type: Object,
      required: true
    }
  },
  computed: {
    trainingDurationString() {
      const doneTrainingDuration = this.getDoneTrainingDuration(this.training)
      return doneTrainingDuration > 0 ? Math.floor(doneTrainingDuration / 60) : '—'
    }
  }
}
</script>
